import api from '../../../../api';

export const LinkSelector = {
  LINK: api.internals.ns.selector('link')
};
